<mat-toolbar color="primary">
	<span>概算見積もり君 🧐</span>
	<span class="spacer"></span>
	<button mat-icon-button (click)="openDialog()">
		<mat-icon>create</mat-icon>
	</button>
</mat-toolbar>

<div class="container">
	<app-form-table></app-form-table>
</div>

<footer>
	<div>
		<a href="https://renaca.jp/" target="_blank" rel="noopener"
			>&copy; Renaca</a
		>
	</div>
	<div>ver.0.0.2</div>
</footer>
